import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { Stack, Typography } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";

import { Button } from "../../../../../components/Button";
import { DialogFooter } from "../../../../../components/DialogFooter";

interface FocusModeOfferBottomSheetProps {
  modalState: UseModalState;
  shiftId: string;
  onOptIn: () => void;
}

export function FocusModeOfferBottomSheet({
  modalState,
  shiftId,
  onOptIn,
}: FocusModeOfferBottomSheetProps) {
  useLogEffect(APP_V2_USER_EVENTS.FOCUS_MODE_OFFER_VIEWED, { shiftId });

  function handleOptIn() {
    onOptIn();
    modalState.closeModal();
  }

  function handleDismiss() {
    logEvent(APP_V2_USER_EVENTS.FOCUS_MODE_DISMISSED, { shiftId });
    modalState.closeModal();
  }

  return (
    <BottomSheet modalState={modalState}>
      <Stack spacing={4} sx={{ padding: 4 }}>
        <Typography variant="h6">Earn bonus points with Focus Mode</Typography>
        <Typography variant="body2">
          Stay in the app during your shift to earn bonus Clipboard points. Focus Mode tracks your
          engagement and rewards you for staying focused.
        </Typography>
      </Stack>
      <DialogFooter
        orientation="vertical"
        actions={
          <>
            <Button variant="contained" onClick={handleOptIn}>
              Enable Focus Mode
            </Button>
            <Button variant="outlined" onClick={handleDismiss}>
              No Thanks
            </Button>
          </>
        }
      />
    </BottomSheet>
  );
}
